import axios from 'axios'
import ApiRotas from './rotas.api'

import ServiceHandler from './handler/service.handler'
import MensagensHelper, { MSG_SUCESSO, MSG_ALERTA } from '@/utils/mensagens.helper'

class PadraoService {
  constructor(rota, msgs) {
    this.rota = rota
    this.msgs = msgs
  }

  async retornaPorId(id) {
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/${id}`)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaTodos(pagina = 0) {
    const params = pagina === 0 ? {} : { params: { p: pagina } }
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaTodosSemLimite() {
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/full`)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async retornaTodosPorFiltro(filtro, pagina = 0) {
    const params = pagina === 0 ? {} : { params: { p: pagina } }
    try {
      const retorno = await axios.get(`${ApiRotas}/${this.rota}/filtrar/${filtro}`, params)
      if (retorno.data) {
        return retorno.data
      }

      throw MensagensHelper.gerar(MSG_ALERTA, this.msgs.NAO_ENCONTRADO_FILTRO)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async gravar(dados) {
    try {
      const retorno = await axios.post(`${ApiRotas}/${this.rota}`, dados)
      return MensagensHelper.gerar(MSG_SUCESSO, this.msgs.CADASTRADO, retorno.data)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }

  async atualizar(dados) {
    try {
      const retorno = await axios.put(`${ApiRotas}/${this.rota}`, dados)
      return MensagensHelper.gerar(MSG_SUCESSO, this.msgs.ATUALIZADO, retorno.data)
    } catch (error) {
      throw ServiceHandler.validar(error)
    }
  }
}

export default PadraoService
